import { FormValidators } from 'utils/form/types';
import { isEmail, isPhone, isRequired } from 'utils/form/validators';
import { EMAIL_SEND_CONTACT_US_FORM } from 'config/email/endpoints';
import EmailBaseFormStore from 'stores/common/EmailBaseFormStore';

export interface ContactUsForm {
  fullName: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
  agreeToReceive: 'yes' | 'no',
}

class NewContactUsFormStore extends EmailBaseFormStore<ContactUsForm> {
  protected get endpoint(): string {
    return EMAIL_SEND_CONTACT_US_FORM;
  }

  protected getInitialForm(): ContactUsForm {
    return {
      fullName: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
      agreeToReceive: 'no',
    };
  }

  protected get validators(): FormValidators<ContactUsForm> {
    return {
      fullName: isRequired(),
      email: [isRequired(), isEmail()],
      phone: [isRequired(), isPhone()],
    };
  }
}

export default NewContactUsFormStore;
